<template>
	<div class="" style="height:100%">
		<div class="selectionBar">
			<div class="flex flex-ai-c flex-jc-sb flex-wrap">
				<label>场景：</label>
				<el-input placeholder="文章标题" v-model="searchValue" size="small" class="input-with-select" style="width:300px;">
					<el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
				</el-input>
				<router-link :to="{ name: '推文添加'}" >
					<el-button type="primary" icon="el-icon-circle-plus-outline" size="small">添加</el-button>
				</router-link>
			</div>
		</div>
		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 140px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
				<el-table-column prop="main_pic" label="主图" width="80" align="center">
					<template slot-scope="scope">
						<el-image :src="getImgUrl(scope.row.main_pic)" fit="cover" class="main_pic" :preview-src-list="[domain + '/' + scope.row.main_pic]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="文章标题" show-overflow-tooltip></el-table-column>
				<el-table-column prop="view_num" label="浏览量" show-overflow-tooltip>
                    <template slot-scope="scope">
						{{scope.row.view_num+scope.row.view_base}}
					</template>
                </el-table-column>
				<el-table-column prop="zan_num" label="点赞量" show-overflow-tooltip>
					<template slot-scope="scope">
						{{scope.row.zan_num+scope.row.zan_base}}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
				<el-table-column fixed="right" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button type="primary" icon="el-icon-zoom-in" size="small" @click="showDetail(scope.row,true)"></el-button>
							<el-button type="primary" icon="el-icon-edit" size="small" @click="showDetail(scope.row)"></el-button>
							<el-button type="primary" icon="el-icon-delete" size="small" @click="del(scope.row)"></el-button>
						</el-button-group>
						<!-- <el-button @click="show(scope.row)" type="text" size="small">
							<router-link :to="{ name: '推文添加',query:{show:true,row:JSON.stringify(scope.row)}}"
								style="color:#409EFF;cursor:pointer">
								查看
							</router-link>
						</el-button> -->
						<!-- <el-button type="text" size="small">
							<router-link :to="{ name: '推文添加',query:{row:JSON.stringify(scope.row)}}"
								style="color:#409EFF;cursor:pointer">
								编辑
							</router-link>
						</el-button> -->
						<!-- <el-button @click="del(scope.row)" type="text" size="small">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr"
					:page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>
		<!-- 图片放大查看 -->
		<el-dialog title="图片查看" :visible.sync="dialogVisible" :modal-append-to-body="false">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				searchValue: '',
				list: [],
				dialogVisible: false,
				dialogImageUrl: '',
				formData: {

				},
				curr: 1, //页码
				row: 10, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.http.post('/admin/article/getList', {
					curr: this.curr,
					row: this.row,
					wd: this.searchValue,
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},
			// 查看图片
			showImg: function(url) {
				this.dialogImageUrl = this.domain + '/' + url;
				this.dialogVisible = true;
			},
			// 图片转换
			getImgUrl(item) {
				var url = this.domain + '/' + item;
				return url;
			},
			showDetail(item,show){
				this.$router.push({
					name:'推文添加',
					query:{
						row:JSON.stringify(item),
						show:show
					}
				})
			},
			
			del(row) {
				this.$confirm(`确定删除吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var url = '/admin/article/delete';
					this.http.post(url, {
						id: row.id,
					}).then(() => {
						this.getList();
						this.$message({
							type: 'success',
							message: '已删除!'
						});
					})
				})
			},
			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			},
		}
	}
</script>

<style lang="css" scoped>
</style>
